export default {
  title: '你好',
  message: {
    contactservice: '请联系客服！',
    enterNewPassword: '请输入新密码',
    passwordLengthError: '密码长度不能小于6',
    reenterNewPassword: '请再次输入新密码',
    passwordComplexityError: '密码必须包含大小写字母和数字以及特殊字符',
    passwordMismatchError: '两次密码不同，请检查',
    enterPhoneNumber: '请输入手机号',
    enterEmail: '请输入邮箱',
    enterVerificationCode: '请输入验证码',
    enterCurrentPassword: '请输入原密码',
    updateSuccess: '修改成功',
    copySuccess: '复制成功',
    withdrawalAmountGreaterThanZero: '提现金额必须大于0',
    operationSuccess: '操作成功',
    registrationSuccess: '报名成功',
    transferSuccess: '转让成功',
    redemptionSuccess: '兑换成功',
    enterPassword: 'Please enter password',
    reenterPassword: 'Please re-enter password',
    agreeToPrivacyPolicy: '请阅读并勾选用户隐私协议',
    confirm: '确认',
    cancel: '取消',
    isImmediateRedeem: '是否立即兑换?',
    confirmWithdrawal: '是否确认提现?',
    prompt: '提示',
    save: '保存',
    saveSuccess: '保存成功',
    loginout: '是否退出登录?',
  },
  sidebar: {
    home: '首页',
    shop: '商城',
    memberpointsdetail: '会员点数明细',
    switchLanguage: '切换语言',
    accountManagement: '账户管理',
    memberManagement: '会员管理',
    menu: '菜单',
    logout: '退出登录',
    accountInfo: '账户信息',
    changePassword: '修改密码',
    bindPhone: '手机绑定',
    viewLoginRecords: '查看登录记录',
    memberPersonalInfo: '会员个人信息',
    referrerInfo: '推荐人信息',
    teamStructure: '团队结构',
    myteam: '团队结构',
    lowerMemberData: '下级会员数据',
    memberVipStatus: '会员VIP状态',
    bonusManagement: '奖金管理',
    incomeDetails: '收益明细',
    eWallet: '电子钱包',
    purchasePackage: '购买套餐',
    selectPackage: '选择套餐',
    memberBenefitsDescription: '会员权益说明',
    purchaseRecords: '购买记录',
    orderManagement: '订单管理',
    pointsSystem: '积分系统',
    myVouchers: '我的优惠码',
    messageNotifications: '消息通知',
  },
  login: {
    login: '登录',
    returnToLogin: '返回登录',
    accountLogin: '账户登录',
    phoneQuickLogin: '手机快速登录',
    enterPhoneOrEmail: '请输入邮箱/用户ID/用户名称',
    enterPassword: '请输入密码',
    enterPhoneNumber: '请输入手机号',
    pleaseSelect: '请选择',
    enterVerificationCode: '请输入验证码',
    sendVerificationCode: '发送验证码',
    rememberLogin: '记住登录',
    forgotPassword: '忘记密码？',
    registerAccount: '注册账号',
    agreeToTerms: '已阅读并同意',
    username: '用户名称',
    enterusername: '请输入用户名称',
    userAgreement: '《用户协议》',
    and: '和',
    privacyPolicy: '《隐私协议》',
    allContents: '的所有内容',
    back: '返回',
    register: '注册',
    registersuccess: '注册成功',
    phoneRegistration: '手机号注册',
    emailRegistration: '邮箱注册',
    enterEmail: '请输入邮箱',
    shoplazzaRegistrationNote: '如已在shoplazza注册，请使用同一个邮箱',
    verificationCode: '验证码',
    password: '密码',
    confirmPassword: '确认密码',
    enterReferrerId: '请输入邀请码',
    referrerId: '邀请码',
    registerAndLoginNow: '立即注册',
    forgotPasswordTitle: '忘记密码',
    newPassword: '新密码',
    enterNewPassword: '请输入新密码',
    confirmNewPassword: '确认新密码',
    registeredPhone: '注册的手机号',
    registeredEmail: '注册的邮箱',
    useEmail: '使用邮箱',
    usePhone: '使用手机号',
    enterRegisteredPhone: '请输入注册时的手机号',
    enterRegisteredEmail: '请输入注册时的邮箱',
    submit: '提交',
    userAgreementText: '用户协议',
    privacyPolicyText: '隐私协议',
  },
  index: {
    home: '首页',
    TiersOrTotal: '10代内/总数',
    vipLevel: 'VIP等级',
    vipPoints: 'VIP点数',
    commissions: '佣金',
    teamSize: '团队规模',
    totalOrders: '总订单数',
    last7Days: '近7天',
    last15Days: '近15天',
    last30Days: '近一个月',
    commissionRanking: '佣金来源排行榜',
    history: '历史',
    account: '账户',
    commission: '佣金',
    incomeTrendChart: '收益趋势图(折线图)',
    incomeName: '收益名称',
    incomeAmount: '收益金额',
    generatedTime: '产生时间',
  },
  accountInfo: {
    accountInfo: '账户信息',
    lastName: '姓',
    firstName: '名',
    company: '公司',
    contactInfo: '联系方式',
    boundEmail: '绑定邮箱',
    address: '地址',
    Edits: '可修改次数1/1',
    Edit: '编辑',
    changeUserID: '修改UserID',
    changeUserIDNote: '只能修改一次，请谨慎操作',
    confirm: '确认修改',
    cancel: '取消',
    enter6DigitNumber: '请输入6位纯数字',
  },
  changepassword: {
    changePassword: '修改密码',
    currentPassword: '原密码',
    enterCurrentPassword: '请输入原密码',
    forgotPassword: '忘记密码？',
    newPassword: '新密码',
    enterNewPassword: '请输入新密码',
    confirmNewPassword: '请确认新密码',
    reenterNewPassword: '请再次输入新密码',
    resetPassword: '忘记密码',
    registeredPhone: '注册的手机号',
    enterPhoneNumber: '请输入手机号',
    registeredEmail: '注册的邮箱',
    useEmail: '使用邮箱',
    usePhone: '使用手机号',
    pleaseSelect: '请选择',
    verificationCode: '验证码',
    enterVerificationCode: '请输入验证码',
    sendCode: '发送验证码',
    cancel: '取消',
    submit: '提交',
    passwordLengthError: '密码长度不能小于6',
    passwordMismatchError: '两次密码不同，请检查',
  },
  bindphone: {
    bindPhone: '手机绑定',
    phoneNumber: '手机号码',
    enterPhoneNumber: '请输入手机号',
    pleaseSelect: '请选择',
    verificationCode: '验证码',
    enterVerificationCode: '请输入验证码',
    sendVerificationCode: '发送验证码',
    submit: '提交',
  },
  loginRecord: {
    loginRecords: '登录记录',
    loginRecordsDesc: '以下是您最近3个月的登录记录，若存在异常登录记录，请尽快',
    changePassword: '修改密码',
    loginIp: '登录IP',
    loginMethod: '登录方式',
    loginTime: '登录时间',
    loginLocation: '登录所在地',
    emailLogin: '邮箱登录',
    phoneLogin: '手机号登录',
  },
  memberinfo: {
    memberPersonalInfo: '会员个人信息',
    basicInfo: '基本信息',
    lastName: '姓',
    firstName: '名',
    company: '公司',
    contactInfo: '联系方式',
    referrerId: '邀请码',
    invitationLink: '邀请链接',
    referralQrcode: '推荐 QRCode(二维码)',
  },
  referrerinfo: {
    referrerInfo: '推荐人信息',
    basicInfo: '基本信息',
    lastName: '姓',
    firstName: '名',
    company: '公司',
    contactInfo: '联系方式',
    referrerId: '推荐人id',
  },
  tree: {
    basicInfo: '基本信息',
    fullName: '用户名称',
    company: '公司',
    contactInfo: '联系方式',
    referrerId: '邀请码',
    invitationLink: '邀请链接',
    referralQrcode: '推荐 QRCode(二维码)',
    teamStructure: '团队结构',
    noData: '暂无数据',
  },
  lowermemberdata: {
    lowerMemberData: '下级会员数据',
    account: '账户',
    remainingVipPoints: 'VIP剩余点数',
    vipStatus: 'VIP状态',
    vipPackageName: 'VIP套餐名称',
    affiliatedNode: '所属节点',
    packageExpiryTime: '套餐过期时间',
    noData: '暂无数据',
    active: '活跃',
    inactive: '未激活',
    vipInactive: 'VIP 未激活',
    nonVip: '非VIP',
    influencer: '网红',
  },
  memberstatus: {
    memberVipStatus: '会员VIP状态',
    basicInfo: '基本信息',
    memberValidityPeriod: '会员有效期',
    memberLevel: '会员等级',
    activeStatus: '活跃状态',
    contactInfo: '联系方式',
    referrerId: '邀请码',
  },
  incomedetails: {
    incomeDetails: '收益明细',
    pleaseSelect: '请选择',
    filter: '筛选',
    money: '奖励金',
    transactionNumber: '流水号',
    creditTime: '入账时间',
    withdrawalTime: '可提现时间',
    noData: '暂无数据',
  },
  LTP10: {
    title: '家族10代团队业绩',
    userId: '用户ID',
    userName: '用户名',
    teamMemberCount: '团队人数',
    teamAccumulatedPerformance: '团队累积业绩',
    startDate: '开始日期',
    endDate: '结束日期',
    createtime: '注册时间',
  },
  ewallet: {
    withdrawalServiceComingSoon: '提现功能即将开放',
    refunded: '已退',
    none: '未处理',
    money: '现金',
    pending: '结算中',
    available: '已入账',
    partial_revoke: '部分撤销',
    revoked: '已撤销',
    available_unlock: '入账解冻',
    eWallet: '电子钱包',
    walletBalance: '钱包余额',
    transactionDetails: '收支明细',
    withdrawalRecords: '提现记录',
    pendingSettlement: '结算中',
    credited: '已入账',
    withdrawable: '可提现',
    vipStatus: 'VIP状态',
    vipActivated: 'VIP 已激活',
    vipInactivated: 'VIP 未激活',
    applyWithdrawal: '申请提现',
    enterWithdrawalAmount: '请输入提现金额',
    withdrawNow: '立即提现',
    pleaseSelect: '请选择',
    filter: '筛选',
    viptip: '暂无权限，请激活会员',
    transactionNumber: '流水号',
    creditTime: '入账时间',
    noData: '暂无数据',
    rejectionReason: '驳回原因',
    reviewTime: '审核时间',
    underReview: '审核中',
    processing: '处理中',
    completed: '已完成',
    success: '成功',
    rejected: '已驳回',
    exchangeHP: '兑换GP',
    rewardExchangeHp: '奖励金兑换GP',
    pleaseEnterRewardToExchange: '请输入要兑换的奖励金',
    youWillGet: '您将会获得',
    confirm: '确认兑换',
    enter: '请输入',
  },
  purchasemeal: {
    currentpackage: '当前套餐',
    purchasePackage: '购买套餐',
    purchaseRecords: '购买记录',
    memberPackage: '会员套餐',
    activeStatus: '活跃状态',
    memberPoints: '会员点数',
    memberLevel: '会员等级',
    memberBenefitsDescription: '会员权益说明',
    rewardGenerations: '奖励代数',
    purchase: '购买',
  },
  memberexplain: {
    memberBenefitsDescription: '会员权益说明',
  },
  purchasehistory: {
    purchaseRecords: '购买记录',
    Count: '购买数量',
    takeEffect: '生效数量',
    name: '名称',
    price: '价格',
    memberPoints: '会员点数',
    rewardGenerations: '可奖励代数',
    purchaseTime: '购买时间',
    status: '状态',
    applyRefund: '申请退款',
    pendingPayment: '待付款',
    paymentProcessing: '付款处理',
    authorized: '已授权',
    partiallyPaidGiftCard: '部分付款（使用礼品卡）',
    paymentReceived: '已收到付款',
    paymentCancelled: '付款已取消',
    paymentFailed: '付款失败',
    refundProcessing: '退款处理',
    refundFailed: '退款失败',
    fullRefund: '全额退款',
    partialRefund: '部分退款',
  },
  order: {
    orderManagement: '订单管理',
    orderNumber: '订单号',
    enterOrderNumber: '请输入订单号',
    orderTime: '订单时间',
    startDate: '开始日期',
    endDate: '结束日期',
    orderStatus: '订单状态',
    pleaseSelect: '请选择',
    filter: '筛选',
    orderInfo: '订单信息',
    orderId: '订单编号',
    customerLastName: '顾客姓氏',
    customerName: '顾客名称',
    customerPhone: '顾客电话',
    totalAmount: '总金额',
    shippingAddress: '收件地址',
    orderDetails: '订单详情',
    applyRefund: '申请退款',
    noData: '暂无数据',
  },
  orderinfo: {
    orderManagement: '订单管理',
    orderInfo: '订单信息',
    orderId: '订单编号',
    notes: '笔记（备注）',
    orderStatus: '订单状态',
    logisticsStatus: '物流状态',
    orderTime: '订单时间',
    paymentInfo: '付款信息',
    paymentMethod: '付款方式',
    totalTax: '总税额',
    currency: '货币',
    totalShippingFee: '总运费',
    totalPrice: '总价',
    customerInfo: '客户信息',
    customerLastName: '客户姓氏',
    shippingAddress: '收件地址',
    customerName: '客户名称',
    phoneNumber: '电话号码',
    refundInfo: '退款信息',
    refundReason: '退款原因',
    applicationTime: '申请时间',
    refundStatus: '退款状态',
    cancelApplication: '取消申请',
  },
  notify: {
    messageNotifications: '消息通知',
    all: '全部',
    systemMessages: '系统消息',
    systemAnnouncements: '系统公告',
    eventNotifications: '活动通知',
    markAllAsRead: '全部已读',
    viewDetails: '查看详情',
    noData: '暂无数据',
  },
  notifyinfo: {
    signUp: '立即报名',
    download: '下载',
  },
  points_RP: {
    pointsDetails: '积分明细',
    pendingSettlement: '结算中',
    settlementAvailable: '可使用（已入账）',
    redeemVoucher: '兑换优惠码',
    redeemGiftCard: '兑换礼品卡',
    transfer: '转让',
    transactionNumber: '流水号',
    creditTime: '入账时间',
    noData: '暂无数据',
    transferHp: '转让GP',
    transferQuantity: '转让数量',
    enterTransferQuantity: '请输入转让数量',
    userUuid: '用户uuid',
    enterUserUuid: '请输入用户uuid',
    hpTransferableBalance: 'GP可转让余额',
    queryUserName: '查询用户名称',
    confirm: '确认',
    cancel: '取消',
    search: '搜索',
  },
  redeem: {
    voucher: '优惠码',
    discount: '折扣',
    requiredPoints: '所需积分',
    minimumSpend: '门槛',
    noMinimumSpend: '无门槛',
    validityPeriod: '有效期',
    to: '到',
    redeemNow: '立即兑换',
    noData: '暂无数据',
    fullReduction: '满',
    designatedProducts: '指定商品',
  },
  redeem_HP: {
    hpRedeemVoucher: 'GP兑换礼品卡',
    pointsBalance: '积分余额',
    operationGuide: '操作指引',
    enterProductPriceToBuy: '请输入要购买的商品价格',
    enterProductPrice: '请输入商品价格',
    redeemValue: '可兑换价值($)',
    enterVoucherRedeemAmount: '请输入兑换礼品卡金额',
    redeemPointsSpent: '兑换支出积分',
  },
  memberpointsdetail: {
    title: '会员点数明细',
    date: '时间',
  },
  exchangecode: {
    redeemVoucher: '兑换优惠码',
    myVouchers: '我的优惠码（RP）',
    myGiftCards: '我的礼品卡（GP）',
    remaining: '剩余',
    voucherCode: '优惠码',
    discount: '折扣',
    redeemType: '兑换类型',
    minimumSpend: '门槛',
    noMinimumSpend: '无门槛',
    validityPeriod: '有效期',
    noExpiry: '无期限',
    reduce: '减',
    to: '到',
    copyVoucherCode: '复制优惠码',
    noData: '暂无数据',
  },
}
